export default "__VITE_ASSET__DsUQar2V__"